export const links = [
    {
        id: 'promo1',
        name: 'Скидка на курс',
        created_at: '2025-04-20',
        total_clicks: 120,
        chart: [
            { time: "2025-04-20 10:00", clicks: 10 },
            { time: "2025-04-20 11:00", clicks: 25 },
            { time: "2025-04-21 12:00", clicks: 35 },
            { time: "2025-04-21 13:00", clicks: 50 },
        ],
        button_clicks: 42,
        conversion: { clicked: 75, ignored: 25 },
    },
    {
        id: 'promo2',
        name: 'Новая функция',
        created_at: '2025-04-21',
        total_clicks: 85,
        chart: [
            { time: "2025-04-21 10:00", clicks: 15 },
            { time: "2025-04-21 11:00", clicks: 20 },
            { time: "2025-04-21 12:00", clicks: 25 },
            { time: "2025-04-21 13:00", clicks: 25 },
        ],
        button_clicks: 30,
        conversion: { clicked: 60, ignored: 40 },
    },
];